import { whatIfInnerSelector } from '../../../WhatIfsSelector';

export const amountSelector = (state, props) => (
  whatIfInnerSelector(state, props).Cost
);

export const estimateCostSelector = (state, props) => (
  whatIfInnerSelector(state, props).EstimateExpenses
);

export default amountSelector;
